import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Option } from "../../../types/General/Option";
import { Dayjs } from "dayjs";
import DatePickerComponent from "../../../components/molecule/DatePicker/DatePickerComponent";
import { Flex } from "@chakra-ui/react";
import SelectComponent from "../../../components/molecule/Select/SelectComponent";

export const documentsSelectedFilteredData = (
  provinceOptions: Option[],
  subSystemOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedYear: (date: Dayjs | null) => void,
  setSelectedProvince: Dispatch<SetStateAction<Option | null>>,
  setSelectedSubSystem: Dispatch<SetStateAction<Option | null>>,
  selectedYear: Dayjs | null,
  provinceLoaded: boolean,
  subSystemLoaded: boolean,
) => {
  const handleProvinceChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedProvinceId = e.target.value;
    const selected = provinceOptions.find(
      (p) => p.id.toString() === selectedProvinceId,
    );
    setSelectedProvince(selected || null);
    setFilter("ProvinceId", selectedProvinceId);
  };

  const handleSubSystemChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedSubSystemId = e.target.value;
    const selected = subSystemOptions.find(
      (p) => p.id.toString() === selectedSubSystemId,
    );
    setSelectedSubSystem(selected || null);
    setFilter("SubSystemId", selectedSubSystemId);
  };

  const handleYearChange = (date: Dayjs | null) => {
    setSelectedYear(date || null);
    setFilter("PublishedAt", date ? date.format("YYYY") : undefined);
  };

  return [
    <Flex
      justifyContent="flex-start"
      alignItems="flex-start"
      gap="4"
      width="230px"
    >
      <SelectComponent
        fieldNameObject="ProvinceId"
        options={provinceOptions}
        fieldName="Província"
        control={control}
        width="230px"
        onChange={handleProvinceChange}
        isLoaded={provinceLoaded}
      />
      <SelectComponent
        fieldNameObject="SubSystemId"
        options={subSystemOptions}
        fieldName="Área específica"
        control={control}
        width="230px"
        onChange={handleSubSystemChange}
        isLoaded={subSystemLoaded}
      />
      <DatePickerComponent
        label="Ano de publicação"
        fieldName="PublishedAt"
        selectedDate={selectedYear}
        onChange={handleYearChange}
        mode="year"
        format="YYYY"
        control={control}
        width="230px"
      />
    </Flex>,
  ];
};
